import { debounce } from '../utilities/common';

/* get any hexagons on the page */
const hexagons = document.querySelectorAll('.hexagon');

/* resize hexagons to fit parent width */
function resizeHexagons() {
  for (let i = 0; i < hexagons.length; i++) {
    const size = hexagons[i].parentElement.clientWidth;
    const width = `${size * 1.083333333}px`;
    const height = `${size* 0.766666667}px`;
    hexagons[i].style.width = height;
    hexagons[i].style.height = width;
  }
}

/* event listeners */
window.addEventListener('load', resizeHexagons);
window.addEventListener('resize', debounce(resizeHexagons));
